import images from "../../imgs";

export const projectTypes = [
    { id: 1, name: "Frontend", slug: "frontend" },
    { id: 2, name: "Fullstack", slug: "fullstack" },
    { id: 3, name: "Backend", slug: "backend" },
    { id: 4, name: "WordPress", slug: "wordpress" },
]
export const programmingLanguages = [
    {
        id: 1,
        name: "JavaScript",
        icon: images["icons/javascript.svg"],
    },
    {
        id: 2,
        name: "TypeScript",
        icon: images["icons/typescript.svg"],
    }
];

export const technologies = [
    {
        id: 1,
        name: "React.js",
        icon: images["icons/react.svg"],
    },
    {
        id: 2,
        name: "Next.js",
        icon: images["icons/nextjs.svg"],
    },
    {
        id: 3,
        name: "Three.js",
        icon: images["icons/threejs.svg"],
    },
    {
        id: 4,
        name: "Bootstrap",
        icon: images["icons/bootstrap.svg"],
    },
    {
        id: 5,
        name: "Tailwind CSS",
        icon: images["icons/tailwindcss-icon.svg"],
    },
    {
        id: 6,
        name: "SASS",
        icon: images["icons/sass.svg"],
    },
    {
        id: 7,
        name: "Node.js",
        icon: images["icons/nodejs.svg"],
    },
    {
        id: 8,
        name: "Express.js",
        icon: images["icons/express.svg"],
    },
    {
        id: 9,
        name: "MongoDB",
        icon: images["icons/mongodb.svg"],
    },
    {
        id: 10,
        name: "MySQL",
        icon: images["icons/mysql.svg"],
    },
    {
        id: 11,
        name: "Wordpress",
        icon: images["icons/wordpress.svg"],
    }
]

export const deploymentPlatforms = [
    {
        id: 1,
        name: "Vercel",
        icon: images["icons/vercel.svg"],
    },
    {
        id: 2,
        name: "AWS EC2",
        icon: images["icons/aws.svg"],
    },
    {
        id: 3, name: "Netlify",
        icon: images["icons/netlify.svg"],
    },
    {
        id: 4,
        name: "Github Pages",
        icon: images["icons/github.svg"],
    },
    {
        id: 5,
        name: "Firebase Hosting",
        icon: images["icons/firebase.svg"],
    }, {
        id: 6,
        name: "Render",
        icon: images["icons/render.svg"],
    }
]
